{
  "organization": {
    "owner": {
      "name": {
        "short": "Owner",
        "long": "Organization owner"
      },
      "description": "Provides full access to the organization, including:<1/>• administrating organization settings, users and teams<1/>• deleting the organization<1/>• all permissions granted to the roles below"
    },
    "project-creator": {
      "name": {
        "short": "Project creator",
        "long": "Project creator"
      },
      "description": "Provides access to project creation as well as all permissions granted to the member role."
    },
    "member": {
      "name": {
        "short": "Member",
        "long": "Organization member"
      },
      "description": "Provides read-only access to the organization (settings, users and teams) and the projects to which they belong."
    },
    "read-only": {
      "name": {
        "short": "Read-Only",
        "long": "Organization Read-Only"
      },
      "description": "Provides read-only access to everything in the organization, including all projects."
    },
    "error": "You do not have the required permissions to access this organization"
  },
  "project": {
    "owner": {
      "name": {
        "short": "Owner",
        "long": "Project owner"
      },
      "description": "Provides full access to the project, including:<1/>• administrating project settings, users and teams<1/>• deleting the project<1/>• all permissions granted to the roles below"
    },
    "cluster-manager": {
      "name": {
        "short": "Cluster manager",
        "long": "Project cluster manager"
      },
      "description": "Can create, modify and delete clusters."
    },
    "read-only": {
      "name": {
        "short": "Read-Only",
        "long": "Project Read-only"
      },
      "description": "May only modify personal preferences."
    },
    "error": "You do not have the required permissions to access this project"
  },
  "cluster": {
    "error": "You do not have the required permissions to access this cluster"
  }
}
